import FormField from "../../../FormField";
import { useIntl } from "react-intl";
const ReviewDetailsStep = ({
  controllerCode,
  language,
  countryLanguages,
  country,
  tokenData,
  salutation,
  title,
  first_name,
  last_name,
  environment,
}) => {
  const intl = useIntl();
  return (
    <div className="row">
      <h5 className="fs-6">Step 1: Review Details</h5>
      <div className="row" style={{ marginBottom: 10 }}>
        <div className="col-md-4">
          <div className="form-group">
            <FormField
              formType="create"
              value={controllerCode?.toUpperCase()?.split("_")[1]}
              name="salutation"
              type="text"
              id="salutation"
              label={intl.formatMessage({
                id: "label.salutation",
                defaultMessage: "Division",
              })}
              placeHolder={intl.formatMessage({
                id: "id.new-placeholder.salutation",
                defaultMessage: "Division",
              })}
              handleChange={() => {}}
              disabled={true}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <FormField
              formType="create"
              value={country?.label}
              name="country"
              type="text"
              id="country"
              label={intl.formatMessage({
                id: "label.salutation",
                defaultMessage: "Country",
              })}
              placeHolder={intl.formatMessage({
                id: "id.new-placeholder.salutation",
                defaultMessage: "Country",
              })}
              handleChange={() => {}}
              disabled={true}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <div className="form-group">
              <FormField
                formType="create"
                value={language}
                name="language"
                type="select"
                id="language"
                label={intl.formatMessage({
                  id: "label.language",
                  defaultMessage: "Language",
                })}
                placeHolder={intl.formatMessage({
                  id: "id.new-placeholder.language",
                  defaultMessage: "Please Select Language",
                })}
                options={countryLanguages}
                disabled={true}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row" style={{ marginBottom: 10 }}>
        <div className="col-md-2">
          <div className="form-group">
            <FormField
              formType="create"
              value={title}
              name="title"
              type="text"
              id="title"
              label={intl.formatMessage({
                id: "label.title",
                defaultMessage: "Title",
              })}
              placeHolder={intl.formatMessage({
                id: "id",
                defaultMessage: "Title",
              })}
              handleChange={() => {}}
              disabled={true}
            />
          </div>
        </div>
        <div className="col-md-2">
          <div className="form-group">
            <FormField
              formType="create"
              value={salutation}
              name="salutation"
              type="text"
              id="salutation"
              label={intl.formatMessage({
                id: "label.salutation",
                defaultMessage: "Salutation",
              })}
              placeHolder={intl.formatMessage({
                id: "id.new-placeholder.salutation",
                defaultMessage: "Salutation",
              })}
              handleChange={() => {}}
              disabled={true}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <FormField
              formType="create"
              value={first_name}
              name="first_name"
              type="text"
              id="first_name"
              label={intl.formatMessage({
                id: "label.first-name",
                defaultMessage: "First Name",
              })}
              placeHolder={intl.formatMessage({
                id: "id.new-placeholder.first-name",
                defaultMessage: "Please Enter First Name",
              })}
              handleChange={() => {}}
              disabled={true}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <FormField
              formType="create"
              value={last_name}
              type="text"
              name="last_name"
              id="last_name"
              label={intl.formatMessage({
                id: "label.last-name",
                defaultMessage: "Last Name",
              })}
              placeHolder={intl.formatMessage({
                id: "id.new-placeholder.last-name",
                defaultMessage: "Please Enter Last Name",
              })}
              handleChange={() => {}}
              disabled={true}
            />
          </div>
        </div>
      </div>
      <div className="row" style={{ marginBottom: 10 }}>
        <div className="col-md-4">
          <div className="form-group">
            <FormField
              formType="create"
              value={tokenData["https://bayer.com/cwid"]}
              name="LoggedInUserCWID"
              type="text"
              id="LoggedInUserCWID"
              label={intl.formatMessage({
                id: "label.salutation",
                defaultMessage: "Logged In User CWID",
              })}
              placeHolder={intl.formatMessage({
                id: "id.new-placeholder.salutation",
                defaultMessage: "Logged In User CWID",
              })}
              handleChange={() => {}}
              disabled={true}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <FormField
              formType="create"
              value={environment}
              name="Environment"
              type="text"
              id="Environment"
              label={intl.formatMessage({
                id: "label.salutation",
                defaultMessage: "Environment",
              })}
              placeHolder={intl.formatMessage({
                id: "id.new-placeholder.salutation",
                defaultMessage: "Environment",
              })}
              handleChange={() => {}}
              disabled={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewDetailsStep;
